<template>
  <div>
    <div class="popup-confirm-mask"></div>
    <div class="popup-confirm">
      <div class="popup-confirm-content">
        <div v-if="title" class="popup-confirm-content-title h3">
          {{ title }}
        </div>
        <div v-if="content" class="popup-confirm-content-desc h4">
          {{ content }}
        </div>
      </div>
      <div class="popup-confirm-btns">
        <div
          v-for="(item, index) in btns"
          :key="index"
          class="popup-confirm-btn"
          :class="{ active: item.type === 'active' }"
          @click="clickBtn(item, $event)"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Confirm",
  props: {
    appender: Object,
    title: String,
    content: String,
    btns: {
      type: Array,
      default() {
        return [
          {
            text: "好",
            key: "close",
            type: "active",
          },
        ];
      },
    },
    onClick: {
      type: Function,
      default(props, ev, self) {
        self.appender &&
          typeof self.appender.close === "function" &&
          self.appender.close();
      },
    },
  },
  mounted() {},
  data() {
    return {
      show: false,
      scale: true,
    };
  },
  methods: {
    open() {
      this.scale = true;
      this.$nextTick(() => (this.show = true));
    },
    close(callback) {
      this.scale = false;
      this.$nextTick(() => {
        this.show = false;
        setTimeout(() => {
          typeof callback === "function" && callback();
        }, 260);
      });
    },
    clickBtn(item, ev) {
      this.onClick({ ...item }, ev, this);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@style/base";
@include setThemeClass {
  .popup-confirm {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1001;
    width: 420px;
    height: 190px;
    background-color: getThemeVal(brandColorWhite);
    // border-radius: 8px;
    padding: 20px 30px 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @include media(
      (
        $sm: (
          width: 320px,
        ),
      )
    );
    .popup-confirm-content {
      padding-bottom: 30px;
      .popup-confirm-content-title + .popup-confirm-content-desc {
        margin-top: 12px;
      }
      .popup-confirm-content-desc {
        @include maxLine(2, 44px);
      }
    }
    .popup-confirm-btns {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .popup-confirm-btn {
        // @include h4(getThemeVal(brandColors));
        color: #000;
        min-width: 80px;
        height: 32px;
        line-height: 32px;
        // background-color: black !important;

        text-align: center;
        border-radius: 30px;
        padding: 0 26px;
        box-sizing: border-box;
        border: 1px solid #000;
        cursor: pointer;
        & + .popup-confirm-btn {
          margin-left: 20px;
        }
        &.active {
          color: getThemeVal(brandColorWhite);
          background-color: getThemeVal(navColorBlack);
          border: none;
        }
      }
    }
  }
  .popup-confirm-mask {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: getThemeVal(navColorBlackOpacity4);
    z-index: 1000;
  }
}
</style>
